import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import axios from "helpers/API";
import { errorBackendMsg } from "helpers/helpers";
import * as Yup from "yup";
import { useFormik } from "formik";
import TurnoPdf from "../admin/turnos/templatePdf/TurnoPdf";
import MsgConfirmacion from "componentes/MsgConfirmacion";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { parserJsonTemplate } from "../admin/turnos/templatePdf/utilsPdf"

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyItems: "center",
    alignItem: "center",
    direction: "column",
    justify: "center",
    maxWidth: "100vw",
    paddingLeft: 20,
    paddingRight: 20,
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
  },
  input100: {
    width: "100%",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CancelarTurno({ volver }) {
  const classes = useStyles();
  const history = useHistory();
  const [datosTurno, setDatosTurno] = useState(null);

  // API Mensaje
  const [mensajeError, setMensajeError] = useState("");
  const [modalConfirmar, setModalConfirmar] = useState(false);
  const [modalExito, setModalExito] = useState(false);
  const [msgExito, setMsgExito] = useState("");
  const [cancelado, setCancelado] = useState(false);

  const handleClose = () => {
    setModalExito(false);
    if (cancelado) {
      volver()
      history.push("/")
    }
  };

  const consultarTurno = (datos) => {
    axios
      .post("/turnos/obtener", datos)
      .then(function (response) {
        if (response.data.error) {
          setMsgExito(response.data.msg);
          setModalExito(true);
        } else {
          setDatosTurno(response.data);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const cancelarTurno = () => {
    axios
      .post("/turnos/cancelar", {
        nroDoc: datosTurno.solicitante.dni,
        nroTurno: datosTurno.turno.nroTurno,
      })
      .then(function (response) {
        if (response.data.error) {
          setMsgExito(response.data.msg);
          setModalExito(true);
        } else {
          setMsgExito("El turno se ha cancelado correctamente");
          setModalExito(true);
          setCancelado(true);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const validationSchema = Yup.object({
    nroDoc: Yup.number()
      .required("Campo requerido")
      .typeError("El DNI tiene que ser un número")
      .min(1000000, "DNI Incorrecto")
      .max(99999999, "DNI Incorrecto"),
    nroTurno: Yup.number()
      .typeError("El número de turno tiene que ser un número")
      .required("Campo requerido"),
  });

  const formik = useFormik({
    initialValues: {
      nroTurno: "",
      nroDoc: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      consultarTurno(values);
    },
  });

  return (
    <>
      {modalConfirmar && (
        <MsgConfirmacion
          setVisible={setModalConfirmar}
          titulo="Cancelar Turno"
          msg={
            "¿Está seguro de cancelar su turno? Esta acción no es reversible"
          }
          aceptar={() => {
            cancelarTurno();
          }}
        />
      )}
      <Dialog
        open={modalExito}
        TransitionComponent={Transition}
        onClose={handleClose}
      >
        <DialogTitle>Cancelar Turno</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {msgExito}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose()} color="secondary">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
      <div>
        <form onSubmit={formik.handleSubmit}>
          <Grid container className={classes.root} spacing={1}>
            <hr />

            <Grid item md={12} xs={12}>
              <Typography variant="h4">Cancelar Turno</Typography>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              style={{ textAlign: "center", marginTop: 20 }}
            >
              <TextField
                variant="outlined"
                className={classes.input100}
                label="Número de Turno"
                type="text"
                id="nroTurno"
                name="nroTurno"
                value={formik.values.nroTurno}
                onChange={formik.handleChange}
                error={
                  formik.touched.nroTurno && Boolean(formik.errors.nroTurno)
                }
                helperText={
                  "Lo podes encontrar en el comprobante que fue enviado a tu email"
                }
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              style={{ textAlign: "center", marginTop: 20 }}
            >
              <TextField
                variant="outlined"
                className={classes.input100}
                label="DNI"
                type="text"
                id="nroDoc"
                name="nroDoc"
                value={formik.values.nroDoc}
                onChange={formik.handleChange}
                error={formik.touched.nroDoc && Boolean(formik.errors.nroDoc)}
                helperText={formik.touched.nroDoc && formik.errors.nroDoc}
              />
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
              style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}
            >
              <Grid item md={12} xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    volver()
                    history.push("/")
                  }}
                >
                  Volver
                </Button>
              </Grid>
              <Button type="submit" variant="contained" color="secondary">
                Buscar
              </Button>
            </Grid>
          </Grid>
        </form>
        {datosTurno && (
          <Grid container className={classes.root} style={{ marginTop: 20 }}>
            <Card>
              <CardHeader
                title={datosTurno.turno.lugar}
                subheader={
                  datosTurno.turno.fecha + ", " + datosTurno.turno.hora
                }
              />
              <CardContent>
                <Box>
                  <Typography>
                    Servicio: <strong>{datosTurno.turno.servicio}</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography>
                    Solicitante:{" "}
                    <strong>{datosTurno.solicitante.nombreCompleto}</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography>
                    DNI: <strong>{datosTurno.solicitante.dni}</strong>
                  </Typography>
                </Box>
              </CardContent>
              <CardActions>
                <Button variant="outlined" size="large">
                  <TurnoPdf nombreArchivo="comprobante.pdf" data={parserJsonTemplate(datosTurno)} />
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  style={{ backgroundColor: "#dd3948", color: "white" }}
                  onClick={() => {
                    setModalConfirmar(true);
                  }}
                >
                  Cancelar
                </Button>
              </CardActions>
            </Card>
          </Grid>
        )}
      </div>
    </>
  );
}

export default CancelarTurno;
